import { Line } from 'react-chartjs-2';
import {useTranslation} from "react-i18next";

export const MonthlyInvoicedChart = (props) => {
    const {
        data
    } = props;
    const {t} = useTranslation();

    const labels = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    const options = {
        responsive: true,
        scales: {
            y: {
                beginAtZero: true
            },
            x: {
                ticks: {
                    callback: function(dataLabel, index) {
                        return t(`months.${labels[dataLabel]}`);
                    }
                }
            }
        },
        plugins:{
            legend:{
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += new Intl.NumberFormat('nl', { style: 'currency', currency: 'EUR' }).format(context.parsed.y);
                        }
                        return label;
                    },
                    title: function(context) {
                        return t(`months.${labels[context[0].dataIndex]}`);
                    }
                }
            }
        }
    }

    const fullData = {
        labels: labels,
        datasets: [
            {
                label: t('charts.invoiced'),
                data: data,
                fill: false,
                backgroundColor: '#97D0C0',
                borderColor: '#36A9E1'
            },
        ],
    }

    return (
        <div>
            <Line data={fullData} options={options}/>
        </div>
    )
}